import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@as/cotopaxi';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { StoreInfoTag } from './StoreInfoTag';
const StoreDepartments = ({ departments }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    if (!departments || departments.length === 0) {
        return null;
    }
    return (_jsx(Box, { paddingBlock: { base: '3', lg: '5' }, children: _jsxs(Stack, { direction: "col", gap: "3", children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingXL", children: t('store.storedepartments.txt') }), _jsx(Grid, { columns: { mobile: 1, tablet: 2, desktop: 3 }, rows: { tablet: 7 }, gap: "s", flow: { mobile: 'row', tablet: 'column' }, children: departments.map(department => (_jsx(StoreInfoTag, { icon: CaretRightIcon, children: _jsx(TextAlpha, { as: "span", children: t(`store.department.${department.code}`) }) }, department.code))) })] }) }));
};
export default StoreDepartments;
